export function formatMoney(value) {
  return `£${Number(value || 0).toFixed(2)}`;
}

// Single source of truth for currency formatting app-wide.
export const formatCurrency = formatMoney;

export function formatDate(value) {
  if (!value) return "—";
  return new Date(value).toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
}
